import React from "react";
import placeholderuser from '../../assets/images/userplaceholder.webp';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
const Newlinkedincampaign = () => {

    return (
        <div className="newuser-container">
            <p className="newuser-title fb-campaign-tittle">Add Linkedin Campaign</p>
            <div className="newuser-form-box">


                <div className="newuser-form">
                    <div className="newuser-field">
                        <label>Campaign Name</label>
                        <input
                            type="text"
                            name="campaignName"
                            placeholder="Enter campaign name"
                            required
                        />
                    </div>
                    <div className="newuser-field">
                        <label>Objective</label>
                        <select name="objective" >
                            <option value="LEAD_GENERATION">Lead Generation</option>
                            <option value="BRAND_AWARENESS">Brand Awareness</option>
                            <option value="WEBSITE_VISITS">Website Visits</option>
                            <option value="ENGAGEMENT">Engagement</option>
                            <option value="VIDEO_VIEWS">Video Views</option>
                        </select>
                    </div>
                    <div className="newuser-field">
                        <label>Ad Format</label>
                        <select name="adFormat" >
                            <option value="SINGLE_IMAGE">Single Image</option>
                            <option value="VIDEO">Video</option>
                            <option value="CAROUSEL">Carousel</option>
                        </select>



                    </div>
                    <div className="newuser-field">
                        <label>Daily Budget (USD)</label>
                        <input
                            type="number"
                            name="dailyBudget"
                            required
                        />

                    </div>
                    <div className="newuser-field">
                        <label>Total Budget (USD)</label>
                        <input
                            type="number"
                            name="totalBudget"
                            required
                        />
                    </div>


                    <div className="newuser-field">
                        <label>Start Date</label>
                        <input
                            type="date"
                            name="startDate"
                            required
                        />


                    </div>
                    <div className="newuser-field">
                        <label>End Date</label>
                        <input
                            type="date"
                            name="endDate"
                            required
                        />

                    </div>
                </div>
                <div className="newuser-form">
                    <div className="newuser-field">
                        <label>Upload Media (Image/Video)</label>
                        <input type="file" name="mediaFile" required />



                    </div>



                    <div className="newuser-field">
                        <label>Target Country</label>
                        <input
                            type="text"
                            name="targetCountry"
                            placeholder="e.g. United States"
                            required
                        />


                    </div>
                    <div className="newuser-field">
                        <label>Age Range</label>
                        <select name="ageRange" >
                            <option value="">Select</option>
                            <option value="18-24">18-24</option>
                            <option value="25-34">25-34</option>
                            <option value="35-44">35-44</option>
                            <option value="45-54">45-54</option>
                            <option value="55+">55+</option>
                        </select>

                    </div>
                    <div className="newuser-field">
                        <label>Gender</label>
                        <select name="gender" >
                            <option value="">Select</option>
                            <option value="ANY">Any</option>
                            <option value="MALE">Male</option>
                            <option value="FEMALE">Female</option>
                        </select>
                    </div>

                    <div className="newuser-field">

                        <label>Ad Headline</label>
                        <input type="text"
                            name="adHeadline"
                            required
                        />

                    </div>
                    <div className="newuser-field">

                        <label>Destination URL</label>
                        <input
                            type="url"
                            name="destinationUrl"
                            placeholder="https://your-website.com"
                            required
                        />

                    </div>


                    <div className='mb-2'>
                        <button type="submit  " className="btn btn-primary newuser-btn">  Save</button>

                    </div>
                </div>
            </div>

            
        </div>
    )
};
export default Newlinkedincampaign